import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { injectIntl } from 'react-intl';

import { default as Actions } from '../actions';
import * as CommonActions from '../../common/actions';

import { Spinner, Card } from '@salesforce/design-system-react/';

import { BrandBand } from '../../common/components';
import { Header, McMenu, Rules } from '../components/';

import './RuleSetup.scss';
import * as Util from '../../common/utilities';

export class RuleSetup extends Component {
  constructor(props) {
    super(props);

    this.unsavedChangesMessage = '';
  }

  componentDidMount() {
    this.props.actions.getAssetTypes();
    this.props.actions.getAttributes();
    this.props.actions.getRules();
  }

  componentDidUpdate(prevProps) {
    if (Util.propChanged(prevProps, this.props, 'dataExtensions.data.status')) {
      if (
        ['queued', 'scheduled'].includes(this.props.dataExtensions.data.status)
      ) {
        // Reload rules and attributes if a profile import started
        this.props.actions.getAttributes();
        this.props.actions.getRules();
      }
    }
  }

  buildUnsavedChangesMessage(rules, loaded) {
    let messages = [];
    const { formatMessage } = this.props.intl;

    if (JSON.stringify(rules.fatigue) !== JSON.stringify(loaded.fatigue)) {
      messages.push(
        formatMessage({ id: 'components.ecs.rules.selection.tab' })
      );
    }
    if (
      JSON.stringify(rules.classifier) !== JSON.stringify(loaded.classifier)
    ) {
      messages.push(formatMessage({ id: 'components.ecs.rules.mapping.tab' }));
    }
    if (JSON.stringify(rules.exclusion) !== JSON.stringify(loaded.exclusion)) {
      messages.push(
        formatMessage({ id: 'components.ecs.rules.exclusion.tab' })
      );
    }
    if (JSON.stringify(rules.variety) !== JSON.stringify(loaded.variety)) {
      messages.push(formatMessage({ id: 'components.ecs.rules.variety.tab' }));
    }

    return messages.join(', ');
  }

  hasDirtyRules = () => {
    const { rules, loaded } = this.props.rules.data;
    if (JSON.stringify(rules) === JSON.stringify(loaded)) {
      return false;
    }
    this.unsavedChangesMessage = this.buildUnsavedChangesMessage(rules, loaded);
    return true;
  };

  renderRules() {
    return (
      <Rules
        actions={this.props.actions}
        assetTypes={this.props.assets.data.types}
        assetKeys={this.props.assets.data.keys}
        assetValues={this.props.assets.data.values}
        assetAttributes={this.props.attributes.data?.assetAttributes || []}
        profileAttributes={this.props.attributes.data?.profileAttributes || []}
        rules={this.props.rules}
        history={this.props.history}
        modals={this.props.modals}
        dataExtensions={this.props.dataExtensions}
        imports={this.props.imports}
        blockNavCriteria={this.hasDirtyRules()}
        modalData={{
          name: 'unsavedChangesModal',
          unsavedChangesMessage: this.unsavedChangesMessage
        }}
        toast={this.props.toast}
      />
    );
  }

  renderSpinner() {
    return (
      <Card className="rules-card">
        <div className="pi-common-spinner">
          <Spinner variant="brand" />
        </div>
      </Card>
    );
  }

  render() {
    const { assets, rules } = this.props;
    const isLoading = assets.isLoading || rules.isLoading;
    return (
      <McMenu
        flags={this.props.flags}
        history={this.props.history}
        route="/rules"
      >
        <BrandBand>
          <Header
            route={this.props.match}
            actions={this.props.actions}
            rules={this.props.rules.data}
            blockNavCriteria={this.hasDirtyRules()}
            modalData={{
              name: 'unsavedChangesModal',
              unsavedChangesMessage: this.unsavedChangesMessage
            }}
          />
          {isLoading ? this.renderSpinner() : this.renderRules()}
        </BrandBand>
      </McMenu>
    );
  }
}

RuleSetup.contextTypes = {
  router: PropTypes.object
};

RuleSetup.propTypes = {
  assets: PropTypes.object,
  attributes: PropTypes.object,
  flags: PropTypes.object,
  rules: PropTypes.object,
  location: PropTypes.object,
  modals: PropTypes.object,
  toast: PropTypes.object
};

function mapStateToProps(state) {
  return {
    assets: state.ecs.assets,
    attributes: state.ecs.attributes,
    flags: state.ecs.flags,
    rules: state.ecs.rules,
    modals: state.modals,
    dataExtensions: state.ecs.dataExtensions,
    imports: state.ecs.imports,
    toast: state.toast
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({ ...Actions, ...CommonActions }, dispatch)
  };
}

export default injectIntl(
  connect(mapStateToProps, mapDispatchToProps)(RuleSetup)
);
